/* Chelsy Hair — réglages choisis dans l'Espace Chelsy, appliqués au site pour toutes les visiteuses :
   pages éteintes, textes et photos modifiés, photos du Book, habillage (couleurs), acompte.
   Les réglages viennent du script Google (action=config) et sont gardés dans le navigateur pour s'afficher sans attendre. */
(function () {
  'use strict';
  var W = window, D = document, CH = W.CHELSY || {}, SCRIPT = CH.script || '';
  var CLE = 'chelsySite', BROUILLON = 'chelsyBrouillon';
  var params = new URLSearchParams(location.search);
  function sess(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  if (params.has('ec_apercu')) sess('ecApercu', '1');
  if (params.has('ec_edition')) sess('ecEdition', '1');
  var apercu = sess('ecApercu') === '1', edition = sess('ecEdition') === '1';
  function lire(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ecrire(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* stockage plein ou bloqué */ } }

  /* ---------- couleurs : 3 teintes choisies, toutes les nuances calculées ---------- */
  function rgb(h) { h = String(h || '').replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function hex(c) { return '#' + c.map(function (x) { return ('0' + Math.round(Math.max(0, Math.min(255, x))).toString(16)).slice(-2); }).join(''); }
  function hsl(h) {
    var c = rgb(h).map(function (x) { return x / 255; }), mx = Math.max.apply(0, c), mn = Math.min.apply(0, c), l = (mx + mn) / 2, s = 0, t = 0, d = mx - mn;
    if (d) { s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn); t = mx === c[0] ? (c[1] - c[2]) / d + (c[1] < c[2] ? 6 : 0) : mx === c[1] ? (c[2] - c[0]) / d + 2 : (c[0] - c[1]) / d + 4; t *= 60; }
    return [t, s * 100, l * 100];
  }
  function deHsl(t, s, l) {
    s /= 100; l /= 100; var k = function (n) { return (n + t / 30) % 12; }, a = s * Math.min(l, 1 - l);
    return hex([0, 8, 4].map(function (n) { return 255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))); }));
  }
  function lum(h, pts) { var x = hsl(h); return deHsl(x[0], x[1], Math.max(0, Math.min(100, x[2] + pts))); }
  function melange(a, b, t) { var x = rgb(a), y = rgb(b); return hex(x.map(function (v, i) { return v + (y[i] - v) * t; })); }
  function luminance(h) { return rgb(h).map(function (v) { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }).reduce(function (s, v, i) { return s + v * [.2126, .7152, .0722][i]; }, 0); }
  function variables(h) {
    if (!h || !h.or || !h.noir || !h.creme) return null;
    var or = h.or, noir = h.noir, creme = h.creme, clairOr = luminance(or) > .42;
    var v = {
      '--or': or, '--or-fonce': h.orFonce || lum(or, clairOr ? -28 : -15), '--or-clair': h.orClair || lum(or, clairOr ? 12 : 22),
      '--noir': noir, '--noir-2': lum(noir, 4), '--brun': lum(noir, 8), '--brun-2': lum(noir, 18),
      '--creme': creme, '--creme-2': lum(creme, -5), '--bordure': lum(creme, -11),
      '--blanc': h.blanc || melange(creme, '#ffffff', .75), '--texte': h.texte || lum(noir, 6)
    };
    v['--texte-doux'] = melange(v['--texte'], creme, .42);
    ['or', 'or-fonce', 'or-clair', 'creme', 'blanc', 'noir'].forEach(function (k) { v['--' + k + '-rgb'] = rgb(v['--' + k]).join(', '); });
    return v;
  }
  var posees = [];
  function habiller(vars) {
    var r = D.documentElement;
    posees.forEach(function (k) { r.style.removeProperty(k); }); posees = [];
    if (!vars) return;
    Object.keys(vars).forEach(function (k) { r.style.setProperty(k, vars[k]); posees.push(k); });
    var m = D.querySelector('meta[name="theme-color"]'); if (m && vars['--noir']) m.content = vars['--noir'];
  }

  /* ---------- pages éteintes : liens cachés partout, page fermée aux visiteuses ---------- */
  var LANGUES = /^\/(en|es|pt|de|it|nl)(?=\/|$)/;
  function chemin(p) { return String(p || '/').replace(LANGUES, '').replace(/\/+$/, '') || '/'; }
  function eteintes(cfg) { var p = (cfg && cfg.pages) || {}; return Object.keys(p).filter(function (k) { return p[k] === false && k !== '/'; }); }
  function cacherLiens(liste) {
    D.querySelectorAll('[data-ec-off]').forEach(function (e) { e.removeAttribute('data-ec-off'); });
    D.querySelectorAll('a[href]').forEach(function (a) {
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var c = chemin(u.pathname);
      if (c !== '/pages/prive-staff' && liste.indexOf(c) < 0) return;
      var li = a.closest('li'), cible = li && li.querySelectorAll('a').length === 1 ? li : a;
      cible.setAttribute('data-ec-off', '');
    });
  }
  function pageFermee(liste) {
    return !apercu && !edition && W.top === W && !CH.editeur && liste.indexOf(chemin(location.pathname)) > -1;
  }

  /* ---------- textes et photos : chaque élément reçoit une clé stable (section + numéro) ---------- */
  var EXCLU = '.shopify-section-group-header-group, header, nav, form, #cha, #chr, .ec, #espaceChelsy, .carte-produit, .book__mur, .menu-mobile, .panier-tiroir, .chiffres, [data-ec-non], [data-ec-ajout], script, style, noscript';
  var TEXTES = 'h1, h2, h3, h4, h5, p, li, blockquote, figcaption, a.btn';
  function cleSection(s) { return (s.id || '').replace(/^shopify-section-/, '').split('__').pop() || 'section'; }
  function marquer() {
    var liste = [];
    D.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.matches(EXCLU) || s.closest(EXCLU)) return;
      var sec = cleSection(s), nt = 0, ni = 0;
      s.querySelectorAll(TEXTES).forEach(function (el) {
        if (el.closest(EXCLU)) return;
        if (el.tagName === 'LI' && el.querySelector('a, button, li')) return;
        var k = sec + '|t' + (nt++);
        if (!el.hasAttribute('data-ec-k')) { el.setAttribute('data-ec-k', k); el.__ecOrig = el.innerHTML; }
        liste.push(el);
      });
      s.querySelectorAll('img').forEach(function (el) {
        if (el.closest(EXCLU)) return;
        var k = sec + '|i' + (ni++);
        if (!el.hasAttribute('data-ec-k')) { el.setAttribute('data-ec-k', k); el.__ecOrig = { src: el.getAttribute('src'), srcset: el.getAttribute('srcset'), sizes: el.getAttribute('sizes') }; }
        liste.push(el);
      });
    });
    return liste;
  }
  function echappe(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function enHtml(t) { return echappe(t).replace(/\*([^*\n]+)\*/g, '<em>$1</em>').replace(/\n/g, '<br>'); }
  function remettre(el) {
    el.removeAttribute('data-ec-cache');
    if (el.tagName === 'IMG') {
      var o = el.__ecOrig || {};
      ['src', 'srcset', 'sizes'].forEach(function (a) { if (o[a] == null) el.removeAttribute(a); else el.setAttribute(a, o[a]); });
    } else if (el.__ecOrig != null && el.__ecModifie) { el.innerHTML = el.__ecOrig; }
    el.__ecModifie = false;
  }
  function poser(el, o) {
    if (o.cache) el.setAttribute('data-ec-cache', '');
    if (el.tagName === 'IMG') {
      if (o.src) {
        el.removeAttribute('srcset'); el.removeAttribute('sizes'); el.setAttribute('src', o.src);
        var pic = el.closest('picture'); if (pic) pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
      }
    } else if (o.t != null) {
      var deco = [].slice.call(el.querySelectorAll('.fleche, [data-i]')).map(function (x) { return x.outerHTML; }).join('');
      el.innerHTML = enHtml(o.t) + (deco ? ' ' + deco : ''); el.__ecModifie = true;
    }
    if (o.plus || o.plusImg) {
      var bloc = D.createElement('div'); bloc.setAttribute('data-ec-ajout', el.getAttribute('data-ec-k')); bloc.className = 'ec-ajout';
      if (o.plus) { var p = D.createElement('p'); p.innerHTML = enHtml(o.plus); bloc.appendChild(p); }
      if (o.plusImg) { var i = new Image(); i.src = o.plusImg; i.alt = ''; i.loading = 'lazy'; bloc.appendChild(i); }
      var apres = el.tagName === 'LI' ? el.closest('ul, ol') || el : el;
      apres.insertAdjacentElement('afterend', bloc);
    }
  }
  function contenus(cfg) {
    D.querySelectorAll('[data-ec-ajout]').forEach(function (e) { e.remove(); });
    var liste = marquer(), page = ((cfg && cfg.contenus) || {})[location.pathname.replace(/\/+$/, '') || '/'] || {};
    liste.forEach(function (el) { remettre(el); var o = page[el.getAttribute('data-ec-k')]; if (o) poser(el, o); });
    return liste;
  }

  /* ---------- Book photo : photos ajoutées depuis l'Espace ---------- */
  function book(cfg) {
    var mur = D.querySelector('[data-book-mur]'); if (!mur) return;
    mur.querySelectorAll('[data-ec-book]').forEach(function (e) { e.remove(); });
    var photos = (cfg && cfg.book && cfg.book.photos) || [];
    mur.querySelectorAll('[data-demo]').forEach(function (e) { e.hidden = photos.length > 0; e.toggleAttribute('data-ec-masque', photos.length > 0); });
    var premier = mur.firstChild;
    photos.forEach(function (ph) {
      if (!ph || !ph.src) return;
      var b = D.createElement('button'); b.type = 'button'; b.className = 'book__tuile revele vu'; b.setAttribute('data-ec-book', '');
      b.dataset.genre = 'photo'; b.dataset.src = ph.src; b.dataset.cat = ph.cat || ''; b.dataset.legende = ph.legende || '';
      b.innerHTML = '<img src="' + echappe(ph.src) + '" alt="' + echappe(ph.legende || '') + '" loading="lazy">' + (ph.legende ? '<span class="book__legende">' + echappe(ph.legende) + '</span>' : '');
      mur.insertBefore(b, premier);
    });
    D.dispatchEvent(new CustomEvent('chelsy:book'));
  }

  /* ---------- tout appliquer ---------- */
  var actuel = null;
  function appliquer(cfg) {
    cfg = cfg || {}; actuel = cfg;
    var liste = eteintes(cfg);
    if (pageFermee(liste)) { location.replace((CH.racine || '') + '/'); return; }
    habiller(variables(cfg.habillage));
    cacherLiens(liste);
    try { contenus(cfg); } catch (e) { /* un contenu ne doit jamais casser la page */ }
    try { book(cfg); } catch (e) { /* idem */ }
    W.CHELSY_CFG = cfg;
    D.dispatchEvent(new CustomEvent('chelsy:config', { detail: cfg }));
  }
  function memoriser(cfg) {
    ecrire(CLE, { t: Date.now(), cfg: cfg, vars: variables(cfg && cfg.habillage), off: eteintes(cfg) });
  }

  var garde = lire(CLE), brouillon = apercu ? lire(BROUILLON) : null;
  appliquer((brouillon && brouillon.cfg) || (garde && garde.cfg));
  function recharger(force) {
    if (!SCRIPT) return Promise.resolve(null);
    return fetch(SCRIPT + '?action=config' + (force ? '&t=' + Date.now() : '')).then(function (r) { return r.json(); }).then(function (cfg) {
      if (!cfg || cfg.ok === false) return null;
      var avant = garde && garde.cfg && garde.cfg.maj;
      memoriser(cfg); garde = lire(CLE);
      if (!apercu && (avant !== cfg.maj || force)) appliquer(cfg);
      return cfg;
    }).catch(function () { return null; });
  }
  if (!garde || Date.now() - (garde.t || 0) > 20000) recharger();

  // navigation fluide : la nouvelle page reçoit les mêmes réglages
  D.addEventListener('chelsy:page', function () { appliquer(actuel); });

  // aperçu ouvert depuis l'Espace : les changements non publiés s'affichent en direct
  if (apercu) {
    D.documentElement.classList.add('ec-mode');
    W.addEventListener('storage', function (e) { if (e.key === BROUILLON) { var b = lire(BROUILLON); appliquer((b && b.cfg) || (garde && garde.cfg)); } });
    var bandeau = D.createElement('div'); bandeau.className = 'ec-bandeau';
    bandeau.innerHTML = '<span>👁 Aperçu · rien n’est encore publié</span><button type="button">Quitter l’aperçu</button>';
    bandeau.querySelector('button').addEventListener('click', function () { sess('ecApercu', null); try { if (W.opener) W.close(); } catch (e) { /* ignore */ } location.href = location.pathname; });
    (D.body ? Promise.resolve() : new Promise(function (r) { D.addEventListener('DOMContentLoaded', r); })).then(function () { D.body.appendChild(bandeau); });
  }
  if (edition) {
    D.documentElement.classList.add('ec-mode');
    var s = D.createElement('script'); s.src = CH.editionJs; s.defer = true; D.head.appendChild(s);
  }

  W.ChelsySite = { appliquer: appliquer, memoriser: memoriser, recharger: recharger, variables: variables, actuel: function () { return actuel; },
    chemin: function () { return location.pathname.replace(/\/+$/, '') || '/'; }, quitterEdition: function () { sess('ecEdition', null); } };
})();
